/**
 * filters.js
 * Lógica de búsqueda y filtrado de recetas.
 * Opera sobre el estado global y devuelve
 * el array filtrado sin modificar el original.
 */

import { getRecetas, getCategoriaActiva, getBusqueda, setFiltradas } from './state.js';

/**
 * Aplica los filtros activos (búsqueda + categoría)
 * sobre el array completo de recetas.
 * Actualiza el estado con el resultado filtrado.
 * @returns {Array} array de recetas filtradas
 */
export function aplicarFiltros() {
  const recetas = getRecetas();
  const categoria = getCategoriaActiva();
  const busqueda = getBusqueda().trim().toLowerCase();

  const filtradas = recetas.filter((receta) => {
    // ── Filtro por categoría ──────────────────────────
    const coincideCategoria = categoria === 'todas' || receta.categoria === categoria;

    // ── Filtro por texto ──────────────────────────────
    // Busca en nombre, ingredientes y preparación
    const coincideTexto =
      busqueda === '' ||
      receta.nombre.toLowerCase().includes(busqueda) ||
      receta.ingredientes.toLowerCase().includes(busqueda) ||
      receta.preparacion.toLowerCase().includes(busqueda);

    return coincideCategoria && coincideTexto;
  });

  filtradas.sort((a, b) => a.nombre.localeCompare(b.nombre, 'es'));

  setFiltradas(filtradas);
  return filtradas;
}

/**
 * Genera la clase CSS del badge según la categoría.
 * @param {string} categoria
 * @returns {string} clase CSS
 */
export function claseBadgeCategoria(categoria) {
  const mapa = {
    'Primer Plato': 'badge-categoria--primer-plato',
    'Segundo Plato': 'badge-categoria--segundo-plato',
    Postres: 'badge-categoria--postres',
    Salsas: 'badge-categoria--salsas',
    Salados: 'badge-categoria--salados',
    Bocadillos: 'badge-categoria--bocadillos',
  };
  return mapa[categoria] ?? 'badge-categoria';
}
